import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  headers: { 'Content-Type': 'application/json' },
});

// Clients
export const getClients = (params) => api.get('/clients', { params });
export const getClient = (id) => api.get(`/clients/${id}`);
export const createClient = (data) => api.post('/clients', data);
export const updateClient = (id, data) => api.put(`/clients/${id}`, data);
export const deleteClient = (id) => api.delete(`/clients/${id}`);

// Campaigns
export const getCampaigns = (params) => api.get('/campaigns', { params });
export const getCampaign = (id) => api.get(`/campaigns/${id}`);
export const createCampaign = (data) => api.post('/campaigns', data);
export const updateCampaign = (id, data) => api.put(`/campaigns/${id}`, data);
export const deleteCampaign = (id) => api.delete(`/campaigns/${id}`);

// Events
export const createEvent = (data) => api.post('/events', data);
export const getEvents = (params) => api.get('/events', { params });

// Analytics
export const getAnalyticsSummary = (params) => api.get('/analytics/summary', { params });
export const getAnalyticsTimeseries = (params) => api.get('/analytics/timeseries', { params });
export const getAnalyticsChannels = (params) => api.get('/analytics/channels', { params });
export const getAnalyticsCreatives = (params) => api.get('/analytics/creatives', { params });

// Creatives
export const getCreatives = (params) => api.get('/creatives', { params });
export const createCreative = (data) => api.post('/creatives', data);
export const deleteCreative = (id) => api.delete(`/creatives/${id}`);

// Tasks
export const getTasks = (params) => api.get('/tasks', { params });
export const createTask = (data) => api.post('/tasks', data);
export const updateTask = (id, data) => api.put(`/tasks/${id}`, data);
export const deleteTask = (id) => api.delete(`/tasks/${id}`);

// Projects
export const getProjects = (params) => api.get('/projects', { params });
export const createProject = (data) => api.post('/projects', data);
export const updateProject = (id, data) => api.put(`/projects/${id}`, data);
export const deleteProject = (id) => api.delete(`/projects/${id}`);

// Contacts
export const createContact = (data) => api.post('/contacts', data);
export const getContacts = () => api.get('/contacts');
export const updateContactStatus = (id, status) => api.put(`/contacts/${id}/status?status=${status}`);
export const deleteContact = (id) => api.delete(`/contacts/${id}`);

// AI
export const aiGenerate = (data) => api.post('/ai/generate', data);
export const getAIHistory = () => api.get('/ai/history');
export const aiChat = (data) => api.post('/ai/chat', data);
export const aiHealth = (token) => api.get('/ai/health', { headers: { Authorization: `Bearer ${token}` } });
export const getChatHistory = (sessionId) => api.get(`/ai/chat/${sessionId}`);

// AI Tool Settings
export const getAIToolSettings = () => api.get('/ai/tool-settings');
export const addCustomCategory = (value, label) => api.post(`/ai/tool-settings/category?value=${value}&label=${label}`);
export const addCustomChannel = (value, label) => api.post(`/ai/tool-settings/channel?value=${value}&label=${label}`);
export const deleteCustomCategory = (value) => api.delete(`/ai/tool-settings/category/${value}`);
export const deleteCustomChannel = (value) => api.delete(`/ai/tool-settings/channel/${value}`);

// Finance
export const getFinanceSummary = () => api.get('/finance/summary');

// Auth
export const getUsers = (token) => api.get('/auth/users', { headers: { Authorization: `Bearer ${token}` } });
export const getRoiLeads = (token) => api.get('/roi/leads', { headers: { Authorization: `Bearer ${token}` } });
export const deleteRoiLead = (id, token) => api.delete(`/roi/leads/${id}`, { headers: { Authorization: `Bearer ${token}` } });
export const updateUser = (id, data, token) => api.put(`/auth/users/${id}`, data, { headers: { Authorization: `Bearer ${token}` } });
export const deleteUser = (id, token) => api.delete(`/auth/users/${id}`, { headers: { Authorization: `Bearer ${token}` } });
export const registerUser = (data) => api.post('/auth/register', data);

// Export
export const getExportUrl = (type, params = {}) => {
  const queryString = new URLSearchParams(params).toString();
  return `${API}/export/${type}${queryString ? '?' + queryString : ''}`;
};

// Seed
export const seedData = () => api.post('/seed');

export default api;
